/* eslint-disable radix */
import config from '@config';
import { pick } from 'lodash/fp';

import createDataSource from './createDataSource';
import { getDefaultEmptyList, getDefaultListHandler } from './utils';

const BASE_PATHNAME = 'where-to-watch';

export const FILTER_OPTION = {
  ALL: {
    key: '',
    label: 'All competitions',
  },
  WORLD_ATHILETICS_SERIES: {
    key: 'was',
    label: 'World Athletics Series',
  },
  DIAMOND_LEAGUE_MEETINGS: {
    key: 'dlm',
    label: 'Diamond League Meetings',
  },
  WORLD_CONTINENTAL_TOUR: {
    key: 'wct',
    label: 'World Continental Tour',
  },
  WORLD_ATHILETICS_INDOOR_TOUR: {
    key: 'wit',
    label: 'World Athletics Indoor Tour',
  },
};

export const DEFAULT_FILTER = FILTER_OPTION.ALL;

export const FILTER_OPTIONS = Object.values(FILTER_OPTION);

export default () => {
  const dataSource = createDataSource(`${config.api.url}`);

  const getById = ({ id }) => dataSource.get(`${BASE_PATHNAME}/${id}`).json();

  const remove = ({ id }) => dataSource.delete(`${BASE_PATHNAME}/${id}`);

  const create = ({ values, id }) => dataSource.post(BASE_PATHNAME, { json: { ...values, id: parseInt(id) } }).json();
  const update = ({ id, values }) =>
    dataSource.put(`${BASE_PATHNAME}`, { json: { ...values, id: parseInt(id) } }).json();

  const getDaysForSchedule = ({ eventIdWa }) =>
    dataSource.get(`${BASE_PATHNAME}/${eventIdWa}/days-for-schedule`).json();

  const save = async ({ id, values }) => (id ? update({ id, values }) : create({ values }));

  return {
    getList: getDefaultListHandler({
      url: BASE_PATHNAME,
      dataSource,
      transformFilter: pick(['categoryCode']),
    }),

    getById,

    remove,

    create,

    update,

    save,

    getDaysForSchedule,

    getEmptyList: getDefaultEmptyList,
  };
};
